import { useContext } from 'react'
import cx from 'classnames'
import { Link } from 'react-router'

import { ButtonToneContext } from '../contexts'
import {
  buttonSizeClasses,
  buttonVariantClasses,
  heroButtonVariantClasses,
} from './buttonStyles'

export const ButtonLink = ({ children, className, href, icon, size = 'md', to, variant = 'primary', ...props }) => {
  const tone = useContext(ButtonToneContext)
  const resolvedVariantClasses = tone === 'hero'
    ? heroButtonVariantClasses[variant]
    : buttonVariantClasses[variant]

  const Component = href ? 'a' : Link
  const destinationProps = href ? { href } : { to }

  return (
    <Component
      className={cx(
        'ds-button tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:rounded-button tw:border tw:font-medium tw:no-underline tw:hover:no-underline',
        'tw:transition-[background-color,border-color,color] tw:duration-fast tw:ease-standard',
        resolvedVariantClasses,
        buttonSizeClasses[size] || buttonSizeClasses.md,
        className,
      )}
      data-tone={tone}
      data-variant={variant}
      {...destinationProps}
      {...props}
    >
      {icon && <span className="ds-button-icon tw:inline-flex">{icon}</span>}
      {children}
    </Component>
  )
}
